import React, { useState, useEffect, useContext, useMemo } from 'react'
import { useIntl } from 'react-intl'
import { Table, UfinetBox, UfinetButton, UfinetSectionBox, formatTableFilters, tableSortValueToSortDirection } from 'ufinet-web-components'
import { AuthContext, Authority, } from 'ufinet-web-functions'
import { colsNextPaymentCommissionSystem } from './NextPaymenCommissionSystemColData'
import { UseQueryNextPaymentCommissionSystem, UseDownloadFileCommissionNextPaymentSys } from 'request'
import { DataTablePageEvent } from 'primereact/datatable'
import { Translation } from 'utils/translation/Translation'
import { CommissionSystemElement } from 'types/commissionSystemTypes'
import { faDownload } from '@fortawesome/free-solid-svg-icons'
import { useQueryCatalogCommissionSystem } from 'request/commissionSystem/catalogs-commission-system-request'

const NextPaymentCommisionSystemPage = () => {
  const intl = useIntl()
  
  const {data: dataType} = useQueryCatalogCommissionSystem.useQueryCatalogType()
  const {data: dataCommissionType} = useQueryCatalogCommissionSystem.useQueryCatalogCommissionType()
  const {data: dataManagementType} = useQueryCatalogCommissionSystem.useQueryCatalogCommissionSystemManagementType()
  
  const colsNextPaymentCommission = useMemo(() => 
    colsNextPaymentCommissionSystem({intl, dataType, dataCommissionType, dataManagementType}),
   [
    intl,
    dataType,
    dataCommissionType,
    dataManagementType,    
   ])

  const authData = useContext(AuthContext)
  const roles = authData.userData?.authorities || []
  const permissions = Authority.getCommissionCmSystemPermissions(roles)

  const [paging, setPaging] = useState<any>()
  const [filterData, setFilterData] = useState<any>()
  const { data: nextPaymentCommssion, isLoading: isLoadingNextPaymentCommision } = UseQueryNextPaymentCommissionSystem(filterData)

  const cbSuccessNextPaymentFile = (data: any) => {

  }

  const { mutate: downloadFile, isLoading: isLoadingCommissionNextPaymentSys } = UseDownloadFileCommissionNextPaymentSys(cbSuccessNextPaymentFile)

  useEffect(() => {
    if (nextPaymentCommssion) {
      const parsePagination = JSON.parse(nextPaymentCommssion?.headers['x-pagination'])
      const formattedPagination = {
        totalElements: parsePagination.totalCount,
        totalPages: parsePagination.totalPages,
        pageSize: parsePagination.pageSize,
        pageNumber: parsePagination.currentPage,
      }
      setPaging(formattedPagination)
    }
  }, [nextPaymentCommssion])

  const onFilterClear = (): void => {
    setFilterData({})
  }

  const onFilter = (e: DataTablePageEvent): void => {
    const formattedFilters = formatTableFilters(e as any)
    setFilterData({
      ...filterData,
      ...formattedFilters
    })
  }

  const onPage = (e: DataTablePageEvent): void => {
    setFilterData({ ...filterData, pageNumber: e.page, pageSize: e.rows })

  }

  const onSort = (e: DataTablePageEvent): void => {
    const finalOrder = tableSortValueToSortDirection(e.sortOrder)
    setFilterData({
      ...filterData,
      sortField: e.sortField,
      sortOrder: finalOrder,
    })

  }

  const downloadFileNextPaymentSys = () => {
    downloadFile(filterData)
  }


  const getHeadersButtons = () => (
    <>
      {permissions.canWrite && (
        <UfinetButton
          className="me-3"
          icon={faDownload}
          onClick={() => downloadFileNextPaymentSys()}
          content={Translation('DOWNLOAD.FILE')}
        />
      )}
    </>
  )

  return (
    <>
      <UfinetBox>
        <UfinetSectionBox>
          <Table
            // selectedValues={selectedValues}
            // onSelectionChange={permissions.canDelete ? onSelectionChange : undefined}
            // onRowEditComplete={permissions.canUpdate ? onRowEditComplete : undefined}
            cols={colsNextPaymentCommission}
            content={nextPaymentCommssion?.data?.commissions?.map((item: CommissionSystemElement) => ({
              ...item,
              username: item.user.username,
              idService: item.service.idService,
              saleMonth: item.service.saleMonth,
              commissionType: item.commission.commissionType,
              exchangeRate: item.commission.exchangeRate,
              saleYear: item.service.saleYear,
              type: item.commission.type,
              backlog: item.service.backlog,
              percentageCommission: item.commission.percentageCommission,
              commissionTypePercentage: item.commission.commissionTypePercentage,
              baseAmount: item.commission.baseAmount,
              totalAmount: item.commission.totalAmount,
              paymentYear: item.commission.paymentYear,
              paymentMonth: item.commission.paymentMonth,
              authorizationDate: item.authorization.authorizationDate,
              paymentId: item.commission.paymentId,
              idServiceCRM: item.service.idServiceCRM,
              serviceName: item.service.serviceName,
              serviceClient: item.service.serviceClient,
              firstBillingDate: item.service.firstBillingDate,
              percentageUser: item.commission.percentageUser,
              managementType: item.service.managementType,
              quoteCode: item.service.quoteCode,
            }))}
            actionBodyTemplate={<></>}
            rowsPerPageOptions={[5, 10, 20, 50, 100, 250]}
            emptyMessage={isLoadingNextPaymentCommision || isLoadingCommissionNextPaymentSys ? intl.formatMessage({ id: 'LOADING_DOTS' }) : undefined}
            onFilterClear={onFilterClear}
            lazySettings={
              paging && {
                ...paging,
                loading: isLoadingNextPaymentCommision || isLoadingCommissionNextPaymentSys,
                onFilter,
                onPage,
                onSort,
              }
            }
            headerButtons={getHeadersButtons()}
          // emptyMessage={loadingRecords ? intl.formatMessage({ id: 'LOADING_DOTS' }) : undefined}
          />
        </UfinetSectionBox>
      </UfinetBox >
    </>
  )
}

export { NextPaymentCommisionSystemPage }
